export const countryProfileConstants = {
    GET_TRADEMAPAGG: 'GET_TRADEMAPAGG',
    GET_MACMAPAGG: 'GET_MACMAPAGG',
    GET_EPMAGG: 'GET_EPMAGG',
    GET_ROOAGG: 'GET_ROOAGG',
    GET_INVESTMENTMAPAGG:'GET_INVESTMENTMAPAGG',
    GET_PROCUREMENTMAPAGG:'GET_PROCUREMENTMAPAGG',
    GET_EPING: 'GET_EPING',

};